export const checksums = {
  "product": "v3.5.0--lx6FkjuEDLr5LBxjnzbQ3zCIDLII-ptIiigRl2fo05k",
  "knowledge": "v3.5.0--ofIsw5JCDLphnd5GBsrCUOa-GL5XcmRbRtErhfgwsHA",
  "developers": "v3.5.0--CFJvDyVoi5Z3F_yEmy_I14bePGccU86OEwDI8iEIRfg",
  "docsApiReferenceLegacyRedirect": "v3.5.0--PGTKm7tQkv9wGiQUBmMS_yT8bMETb-t-B73xPzJ83QE",
  "siteBlocks": "v3.5.0--bh1HEswsOqgO3JOps72Ck3f7r4nDmozYQzviFE1zxc8",
  "home": "v3.5.0--AhG738biQnV28eJ-WUqDLO_HAe9KFT73_p2ldvJLv7A",
  "settings": "v3.5.0--95ZvWS8C2n-ykH_ZpEjNxw2K3vyMc-kZ4CpV5j_lyOA",
  "translations": "v3.5.0--CNTQLI7-xsABxy6eK6vAr7tyevMquQu2iBAUX9BMPjY",
  "booking": "v3.5.0--N7g0I69AUlEPL10J0Z289MCFRn4y3DGAeShWatXbr_w",
  "bookingTerms": "v3.5.0--rV_rEhlQARrxq6OANeifDrpsqd-mxdLJ3e_E3MlhBIw",
  "validate": "v3.5.0--thJsGikZ0kCJAE6sJcp_32xV0WmKkjPM8yRVEanV6H4",
  "start": "v3.5.0--dEYqbSvbQIVAgi-OyddJpS2jWN132Vft3XxHXkGR7eg",
  "legal": "v3.5.0---QzjBsoAP4LXDdInFfQdS6eAp6d66ycJ7mQ-ABYsrcY",
  "archives": "v3.5.0--e8HvbkYJOuvlXW1V1Pvft717NEJMU4ECMstxQeztFR4",
  "articles": "v3.5.0--_AijKV2Xy67_XlWOfgvPuAszCaiMi7YBMJd2NGbRp1w",
  "sections": "v3.5.0--aSWCg0qiq_CVXUk1dFpmrVqxK9DZMWFVH4UhgP0suXw",
  "blog": "v3.5.0--u4YKLeFuUHM3pyxyu_OFPK9o7_XOMLeDaUcZToubfZA",
  "sitesMeta": "v3.5.0--q2A58irbT-hqYCqSaAjucNM3cYHDIS82zdDb5Mak8ZM",
  "commercial": "v3.5.0--MnWZtK2xKUAazLtlvcPod7WqSEm3O-Op72oE0-ctpk4"
}
export const checksumsStructure = {
  "product": "edKzK8-QCgs8cMFZ9gVNXrSc-yoHncu5kl8MuwfKryU",
  "knowledge": "iBMVMW2vtCBCK0bqyb2G6sh8fOIsWwjbyr2xgQWHCCY",
  "developers": "AwNcBJmxDh2GCl368PQyy3xafyBIsbB5ntB-x_vU_KA",
  "docsApiReferenceLegacyRedirect": "mSpVgG1ug4hMj30w7X6zjinbmsNSlZOdGZZEjZzMzB4",
  "siteBlocks": "bh1HEswsOqgO3JOps72Ck3f7r4nDmozYQzviFE1zxc8",
  "home": "aRh723YIihN3PHg_Q-uUtDZrn_un8VY8SoO-KIVszjU",
  "settings": "Pexa98gru0wfofZRQFgAKkl5dxfWC6BeIMjZmFYI9FE",
  "translations": "MJ9-E3JVM9_UnpACNricuz31FiaAsO2ULTjF3gh2zsA",
  "booking": "F5kAH8lGtAysnwLbG1-l8pBb9jDW701ah_yMedfCBrk",
  "bookingTerms": "Dt0RUgQMyj9RCG4WtkfcMInNOnffmqEmGVe7pOxV3aI",
  "validate": "FfhSE0cTRpKmRhpGIGPAD7gkcMOfsTOsbT_ctfGDdn4",
  "start": "ziWmJKt3ytY7OZgPUCBq7q9oEQfDTfQbBbTV1WNYBxA",
  "legal": "-QzjBsoAP4LXDdInFfQdS6eAp6d66ycJ7mQ-ABYsrcY",
  "archives": "9HsPEmPaOrSl8FZkofAQ0IZpdiLRVorTEhSONvRBcGQ",
  "articles": "DDZxwNsEsYzVpY9kx3LhCyffbObjxP4lH8GHFxQSu0I",
  "sections": "P8gvif-pR3rhPXZBSE92Q9vrHSS3uLQwZZDQy4KNzSo",
  "blog": "wettwhYLOIDJ2JQ5PcIIOtEljK5t-jt8r6Xom_FAvJ0",
  "sitesMeta": "q2A58irbT-hqYCqSaAjucNM3cYHDIS82zdDb5Mak8ZM",
  "commercial": "WIsjCe7XvSxZVI1I3bvNi6SOg_QdBu_hoT03RxhQXT8"
}

export const tables = {
  "product": "_content_product",
  "knowledge": "_content_knowledge",
  "developers": "_content_developers",
  "docsApiReferenceLegacyRedirect": "_content_docsApiReferenceLegacyRedirect",
  "siteBlocks": "_content_siteBlocks",
  "home": "_content_home",
  "settings": "_content_settings",
  "translations": "_content_translations",
  "booking": "_content_booking",
  "bookingTerms": "_content_bookingTerms",
  "validate": "_content_validate",
  "start": "_content_start",
  "legal": "_content_legal",
  "archives": "_content_archives",
  "articles": "_content_articles",
  "sections": "_content_sections",
  "blog": "_content_blog",
  "sitesMeta": "_content_sitesMeta",
  "commercial": "_content_commercial",
  "info": "_content_info"
}

export default {
  "product": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "knowledge": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "developers": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "docsApiReferenceLegacyRedirect": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "siteBlocks": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "home": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "settings": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "archives": "json",
      "body": "json",
      "chat": "json",
      "description": "string",
      "docs_external_links": "json",
      "extension": "string",
      "footer": "json",
      "header": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "translations": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "more_other": "string",
      "navigation": "json",
      "on_this_page": "string",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "view_all": "string"
    }
  },
  "booking": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "confirm": "json",
      "datetime": "json",
      "description": "string",
      "details": "json",
      "errors": "json",
      "extension": "string",
      "intro": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "qualify": "json",
      "seo": "json",
      "service": "json",
      "stem": "string",
      "stepper": "json",
      "success": "json"
    }
  },
  "bookingTerms": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "terms": "json"
    }
  },
  "validate": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "assertions": "json",
      "body": "json",
      "description": "string",
      "dropzone": "json",
      "errors": "json",
      "extension": "string",
      "intro": "json",
      "meta": "json",
      "navigation": "json",
      "options": "json",
      "path": "string",
      "report": "json",
      "seo": "json",
      "status": "json",
      "stem": "string"
    }
  },
  "start": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "countdown": "json",
      "description": "string",
      "error": "json",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "panel": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "legal": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "search_boost": "number",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "show_chat": "boolean",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "archives": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "body": "json",
      "canonical": "string",
      "description": "string",
      "extension": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "listed": "boolean",
      "meta": "json",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "author": "string",
      "body": "json",
      "canonical": "string",
      "category": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "featuredImage": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "listed": "boolean",
      "meta": "json",
      "navigation": "json",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "stem": "string",
      "tags": "json",
      "translationKey": "string"
    }
  },
  "sections": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "author": "string",
      "body": "json",
      "canonical": "string",
      "columns": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "external_url": "string",
      "icon": "string",
      "image": "string",
      "keywords": "json",
      "last_reviewed": "string",
      "last_updated": "string",
      "layout": "string",
      "listed": "boolean",
      "meta": "json",
      "nav_column": "string",
      "nav_tab": "string",
      "navigation": "boolean",
      "no_index": "boolean",
      "path": "string",
      "redirect": "string",
      "schema_type": "string",
      "seo": "json",
      "seo_description": "string",
      "seo_title": "string",
      "stem": "string",
      "tabs": "json",
      "tags": "json",
      "translationKey": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "author": "string",
      "body": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "redirect": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "sitesMeta": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "meta": "json",
      "name": "string",
      "navigation": "json",
      "path": "string",
      "redirect": "string",
      "seo": "json",
      "stem": "string",
      "translationKey": "string"
    }
  },
  "commercial": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "auth": "json",
      "author": "string",
      "body": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "icon": "string",
      "image": "string",
      "listed": "boolean",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "redirect": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json",
      "translationKey": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}